// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateAccountForm_container__3b_8o","terms":"CreateAccountForm_terms__Ogm_j","loginButton":"CreateAccountForm_loginButton__1uORe"};